import * as React from "react";
import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "../ui/button";
import { Alert, AlertDescription, AlertTitle } from "../ui/alert";

interface CenteredErrorProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

const RankingErrorHandler: React.FC<CenteredErrorProps> = ({
  title = "Something went wrong",
  message = "We couldn’t load the data. Please check your internet connection or try again.",
  onRetry,
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <Alert
        variant="destructive"
        className="max-w-md w-full border border-red-200 
                   bg-red-50 dark:bg-red-950/40 
                   text-red-700 dark:text-red-300 
                   shadow-sm rounded-xl"
      >
        <div className="flex items-start gap-3">
          <AlertCircle className="h-6 w-6 text-red-600 dark:text-red-400 mt-0.5" />

          <div className="flex-1">
            <AlertTitle className="font-semibold text-red-800 dark:text-red-200">
              {title}
            </AlertTitle>

            <AlertDescription className="text-sm mt-1 text-red-600 dark:text-red-300">
              {message}
            </AlertDescription>

            {onRetry && (
              <Button
                onClick={onRetry}
                variant="destructive"
                size="sm"
                className="mt-4 flex items-center gap-2"
              >
                <RefreshCw className="h-4 w-4" />
                Retry
              </Button>
            )}
          </div>
        </div>
      </Alert>
    </div>
  );
};

export default RankingErrorHandler;
